import { PivotWithCellMarker } from 'components/widget/CrosstabWidgets/types'
import { Pivot } from 'schemas/PivotSchema'
import { Metric } from 'schemas/MetricSchema'
import CrosstabDisplayTypeDetail from 'enums/CrosstabDisplayTypeDetail'

const resolveSum = (crossTabs: PivotWithCellMarker[]) => {
  const rowGrandTotalCells = crossTabs?.filter(
    (crossTab: PivotWithCellMarker) =>
      crossTab.cellMarker === CrosstabDisplayTypeDetail.ROW_GRAND_TOTAL
  )

  if (rowGrandTotalCells.length > 0) {
    return rowGrandTotalCells.reduce((accumulator: number, crossTab: Pivot) => {
      const metrics: Metric[] = crossTab.metrics as Metric[]
      const value = metrics?.[0]?.dataset?.[0]?.set?.[0]
      return accumulator + (value || 0)
    }, 0)
  }

  return crossTabs?.reduce((accumulator: number, crossTab: Pivot) => {
    const metrics: Metric[] = crossTab.metrics as Metric[]
    const value = metrics?.[0]?.dataset?.[0]?.set?.[0]
    return accumulator + (value || 0)
  }, 0)
}

export default resolveSum
